//import axios from '../api/axios';
import { axiosPrivate } from "../services/api";
import useAuth from '../hooks/useAuth';
import { jwtDecode } from "jwt-decode";
import Cookies from 'universal-cookie';

const useRefreshToken = () => {
    const { auth, setAuth, getSessionId } = useAuth();

    const refresh = async () => {

        try {

            //const response = await axiosPrivate.post('/PageInfoRefresh', { em: 'thiagolemedasilva@hotmail.com'/*auth?.user*/ });
            //const response = await axiosPrivate.post('/PageInfoRefresh', { em: auth?.user !== undefined ? auth?.user : "" });
            //console.log('Refresh token',auth);
            //const response = await axiosPrivate.post('/PageInfoRefresh', {si : getSessionId()});
            
            const response = await axiosPrivate.post('/PageInfoRefresh');

            if (response.status === 200) {

                if (response.data !== null && response.data !== undefined && response.data !== "") {

                    try {

                        setAuth({ user: response.data.user, user_ini: response.data.user_ini, access_token: response.data.access_token, menu_info: response.data.menu_info });

                    } catch (e) {
                        setAuth({ user: "", user_ini: "", access_token: "", menu_info: [] });
                    }

                }else{
                    //console.log('headers', response);
                }
            } else {
                setAuth({ user: "", user_ini: "", access_token: "", menu_info: [] });
            }

        } catch (err) {
            console.log('Erro ao carregar informações');
        }

    }
    return refresh;
};

export default useRefreshToken;
